import type { FC } from "react";
import type { IconProps } from "../../media-and-icons/icon/Icon";
import { Icon } from "../../media-and-icons/icon/Icon";

export const ChevronLeftIcon: FC<IconProps> = ({ css, ...props }) => (
    <Icon width="7px" height="15px" viewBox="0 0 7 12" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.70711 0.292893C7.09763 0.683418 7.09763 1.31658 6.70711 1.70711L2.41421 6L6.70711 10.2929C7.09763 10.6834 7.09763 11.3166 6.70711 11.7071C6.31658 12.0976 5.68342 12.0976 5.29289 11.7071L0.292893 6.70711C-0.0976313 6.31658 -0.0976312 5.68342 0.292893 5.29289L5.29289 0.292893C5.68342 -0.0976312 6.31658 -0.0976311 6.70711 0.292893Z"
            fill="currentColor"
            strokeWidth="1.7px"
        />
    </Icon>
);

export const ChevronRightIcon: FC<IconProps> = ({ css, ...props }) => (
    <Icon width="7px" height="15px" viewBox="0 0 7 12" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.292893 11.7071C-0.0976311 11.3166 -0.0976311 10.6834 0.292893 10.2929L4.58579 6L0.292893 1.70711C-0.097631 1.31658 -0.097631 0.683417 0.292893 0.292893C0.683418 -0.0976314 1.31658 -0.0976314 1.70711 0.292893L6.70711 5.29289C7.09763 5.68342 7.09763 6.31658 6.70711 6.70711L1.70711 11.7071C1.31658 12.0976 0.683417 12.0976 0.292893 11.7071Z"
            fill="currentColor"
            strokeWidth="1.7px"
        />
    </Icon>
);

export const PlayIcon: FC<IconProps> = ({ css, ...props }) => (
    <Icon width="24px" height="24px" viewBox="0 0 24 24" {...props}>
        <path
            d="M7 7.75386C7 7.18113 7.66496 6.81849 8.20882 7.09415L16.577 11.3408C16.7051 11.4057 16.8119 11.5012 16.8863 11.6173C16.9607 11.7333 17 11.8657 17 12.0005C17 12.1354 16.9607 12.2677 16.8863 12.3838C16.8119 12.4998 16.7051 12.5953 16.577 12.6602L8.20882 16.9069C8.08459 16.9699 7.94471 17.002 7.80296 16.9999C7.66121 16.9978 7.52249 16.9617 7.40048 16.8952C7.27846 16.8286 7.17735 16.7338 7.10713 16.6202C7.0369 16.5065 6.99998 16.378 7 16.2472V7.75386Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
        />
    </Icon>
);

export const PauseIcon: FC<IconProps> = ({ css, ...props }) => (
    <Icon width="24px" height="24px" viewBox="0 0 24 24" {...props}>
        <path
            d="M15 6.5V17.5M9 6.5V17.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);
